import { queryClient } from '@warehouse/shared/infra';
import { NxObjectHashBuilder } from './nx-object-hash-builder';

/**
 * Marks the object's cached read stale so every watcher refetches it — e.g. after a job wrote new metadata, or to
 * renew the proxy media URLs the Inventory API re-signs on every read.
 */
export function refetchNxObject(nxObjectUuid: string): void {
	queryClient.invalidateQueries({ queryKey: NxObjectHashBuilder.createGetQueryHash({ nxObjectUuid }) });
}
